var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.028 3L23 5.973 19 9l.009-2.001L19 7h-1.676l-.243.006c-1.618.079-3.104.938-3.977 2.313L11.4 12l1.704 2.68c.873 1.376 2.36 2.235 3.977 2.314l.243.006H19l.019.001.01-2.001L23 17.973 19 21l.009-2.001L19 19h-1.676c-2.306 0-4.459-1.136-5.762-3.026l-.147-.221-1.199-1.889-1.198 1.889-.147.221C7.568 17.864 5.416 19 3.11 19H2l-.117-.007C1.386 18.936 1 18.513 1 18c0-.552.448-1 1-1h1.109l.243-.006c1.618-.079 3.104-.938 3.977-2.313L9.032 12 7.329 9.32C6.456 7.943 4.97 7.084 3.352 7.005L3.11 7H2c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L2 5h1.109c2.307 0 4.46 1.136 5.762 3.026l.147.221 1.198 1.888 1.2-1.888.146-.221C12.865 6.136 15.018 5 17.324 5H19l.019.001.01-2.001z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.209ddcf7.svg";
export { ForwardRef as ReactComponent };